import React from 'react';
import reactStringReplace from 'react-string-replace';

import locKeys from '../i18n';
import i18nChoicePattern from './i18nChoicePattern';

const LOCALE_STORAGE_KEY = 'ledium:locale';
export type Locale = 'en' | 'hu';
const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
const currentLocale: Locale = stored === 'hu' ? 'hu' : 'en';

export function setLocale(locale: Locale): void {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
    window.location.reload();
}

export function getLocale(): Locale {
    return currentLocale;
}

function i18n(key: string, ...params: Array<string | number | React.ReactNode>): string | React.ReactNode {
    const langKeys = locKeys[currentLocale] as Record<string, string | undefined>;
    const rawValue = langKeys[key];
    if (!rawValue) {
        return `i18n: ${key}`;
    }

    const isParams = rawValue.match(/(\{\d+\})/g);
    let value: string | React.ReactNode[] = i18nChoicePattern(rawValue, params);

    if (isParams) {
        const uniqueParamCount = new Set(isParams).size;
        if (uniqueParamCount !== params.length) {
            console.error('i18n: Param count error for ' + key);
        }
        params.forEach((param, idx) => {
            if (typeof param === 'object' && param !== null) {
                value = reactStringReplace(value, '{' + idx + '}', (_match, i) =>
                    React.cloneElement(param as React.ReactElement, { key: `${idx}-${i}` })
                ) as React.ReactNode[];
            } else {
                value = (value as string).replaceAll('{' + idx + '}', String(param));
            }
        });
    }

    return value;
}

export default i18n;
